import {crc16} from "app/xEcoApm/helper/crc";

/**
 * Encodes an object into a framed BLE message as a byte array.
 *
 * The payload is JSON-serialized, then wrapped in the frame format:
 * `c<json>0x<XXXX>\r` where `XXXX` is the 4-digit uppercase hex CRC-16
 * of the UTF-8-encoded JSON string.
 *
 * @param payload the object to serialize and transmit.
 * @returns       a byte array representing the complete framed message.
 */
export default (payload: object): number[] => {
  const encode = new TextEncoder()
  const message = JSON.stringify(payload)

  console.log('encode:message', payload)

  const encodedMessage = encode.encode(message)
  const crc = crc16(encodedMessage)
  const crcHex = crc.toString(16).toUpperCase().padStart(4, '0')

  return [...encode.encode(`c${message}0x${crcHex}\r`)]
}
